<template>
  <a-card class="section-card compare-card" :bordered="false">
    <a-tabs default-active-key="team">
      <a-tab-pane key="team" tab="团队比拼">
        <div class="compare-list">
          <div class="compare-item" v-for="item in teamList" :key="item.name">
            <div class="compare-side left">
              <div class="compare-value">{{ item.customerValue }}</div>
              <a-progress :percent="item.customerPercent" :show-info="false" />
            </div>
            <div class="compare-name">{{ item.name }}</div>
            <div class="compare-side right">
              <a-progress :percent="item.salePercent" :show-info="false" />
              <div class="compare-value">{{ item.saleValue }}</div>
            </div>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="convert" tab="转化比拼">
        <div class="compare-list">
          <div class="compare-item" v-for="item in convertList" :key="item.name">
            <div class="compare-side left">
              <div class="compare-value">{{ item.customerValue }}</div>
              <a-progress :percent="item.customerPercent" :show-info="false" />
            </div>
            <div class="compare-name">{{ item.name }}</div>
            <div class="compare-side right">
              <a-progress :percent="item.salePercent" :show-info="false" />
              <div class="compare-value">{{ item.saleValue }}</div>
            </div>
          </div>
        </div>
      </a-tab-pane>
      <div slot="tabBarExtraContent" class="tab-extra">
        <a-radio-group size="small" :value="compareRange">
          <a-radio-button value="日">日</a-radio-button>
          <a-radio-button value="周">周</a-radio-button>
          <a-radio-button value="月">月</a-radio-button>
          <a-radio-button value="年">年</a-radio-button>
        </a-radio-group>
        <a-select size="small" :value="compareMonth" class="filter-select">
          <a-select-option value="2024-08">2024-08</a-select-option>
        </a-select>
      </div>
    </a-tabs>
  </a-card>
</template>

<script>
export default {
  name: 'TeamAnalysisTab',

  data() {
    return {
      compareRange: '月',
      compareMonth: '2024-08',
      teamList: [
        { name: '员工姓名1', customerValue: '25组', customerPercent: 90, saleValue: '23008.65万', salePercent: 85 },
        { name: '员工姓名2', customerValue: '20组', customerPercent: 78, saleValue: '20745.80万', salePercent: 80 },
        { name: '员工姓名3', customerValue: '18组', customerPercent: 72, saleValue: '17852.20万', salePercent: 68 },
        { name: '员工姓名4', customerValue: '17组', customerPercent: 68, saleValue: '23008.65万', salePercent: 85 },
        { name: '员工姓名5', customerValue: '20组', customerPercent: 78, saleValue: '20745.80万', salePercent: 80 },
        { name: '员工姓名6', customerValue: '21组', customerPercent: 82, saleValue: '17852.20万', salePercent: 68 },
        { name: '员工姓名7', customerValue: '15组', customerPercent: 60, saleValue: '23008.65万', salePercent: 85 },
        { name: '员工姓名8', customerValue: '19组', customerPercent: 74, saleValue: '20745.80万', salePercent: 80 }
      ],
      convertList: [
        { name: '员工姓名1', customerValue: '25组', customerPercent: 90, saleValue: '23008.65万', salePercent: 85 },
        { name: '员工姓名2', customerValue: '20组', customerPercent: 78, saleValue: '20745.80万', salePercent: 80 },
        { name: '员工姓名3', customerValue: '18组', customerPercent: 72, saleValue: '78452.20万', salePercent: 100 },
        { name: '员工姓名4', customerValue: '17组', customerPercent: 68, saleValue: '23008.65万', salePercent: 85 },
        { name: '员工姓名5', customerValue: '20组', customerPercent: 78, saleValue: '20745.80万', salePercent: 80 },
        { name: '员工姓名6', customerValue: '21组', customerPercent: 82, saleValue: '78452.20万', salePercent: 100 }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.compare-card :deep(.ant-tabs-bar) {
  margin: 0 0 12px;
}

.tab-extra {
  display: flex;
  align-items: center;
  gap: 8px;
}

.compare-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.compare-item {
  display: grid;
  grid-template-columns: 1fr 70px 1fr;
  align-items: center;
  gap: 10px;
}

.compare-side {
  display: flex;
  align-items: center;
  gap: 8px;
}

.compare-side.right {
  justify-content: flex-end;
}

.compare-name {
  text-align: center;
  font-size: 12px;
  color: #5b6b7c;
}

.compare-value {
  font-size: 12px;
  color: #2b6de5;
  min-width: 58px;
}
</style>
